module.exports = __webpack_public_path__ + "img/pic_permission.89984820.png";